module.exports = __webpack_public_path__ + "img/whitening-512.5597083a.png";